import React, { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest, storageRequest, flaskApiRequest } from "../../authConfig";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { useAuthContext } from "../../contexts/AuthContext";
import { useSocket } from "../../contexts/SocketContext";

// import { PublicClientApplication } from "@azure/msal-browser";

// const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 * Note the [useMsal] package 
 */

export const SignInButton = () => {
  const { instance } = useMsal();
  const { AuthData, setAuthData, updateAuthData } = useAuthContext();
  const { setAuthToken } = useSocket();

  useEffect(() => { console.log("AuthData:", AuthData) }, [AuthData])


  const handleLogin = async (loginType) => {
    // sessionStorage.removeItem("flaskAccessToken");
    // sessionStorage.removeItem("storageAccessToken");
    try {
      let loginResponse;
      if (loginType === "popup") {
        loginResponse = await instance.loginPopup(loginRequest);
        // console.log("response: ", response);
        // console.log("Graph Access Token:", loginResponse.accessToken);

      } else if (loginType === "redirect") {
        loginResponse = await instance.loginRedirect(loginRequest);
        // console.log("Graph Access Token:", loginResponse.accessToken);
      }
      // 執行登入
      // const loginResponse = await instance.loginPopup(loginRequest);
      // console.log("Login Response:", loginResponse);

      // 設置 activeAccount
      instance.setActiveAccount(loginResponse.account);

      // 驗證是否有 activeAccount
      const activeAccount = instance.getActiveAccount();
      if (!activeAccount) {
        console.error("No active account found!");
        return;
      }


      // 獲取 Access Token
      const storageTokenResponse = await instance.acquireTokenSilent({
        ...storageRequest,
        account: activeAccount,
      });
      // console.log("Storage Access Token:", storageTokenResponse.accessToken);
      // ❗️存在 sessionStorage
      sessionStorage.setItem("storageAccessToken", storageTokenResponse.accessToken);

      let tokenResult;
      try {
        tokenResult = await instance.acquireTokenSilent({
          ...flaskApiRequest,
          account: activeAccount,
        });
        console.log("🟢 使用 silent 拿 token 成功");
      } catch (error) {
        // 使用者「需要同意權限時」會看到彈出視窗
        if (error instanceof InteractionRequiredAuthError) {
          console.warn("🔁 Silent token 失敗，改用 popup 取得 token");
          tokenResult = await instance.acquireTokenPopup({
            ...flaskApiRequest,
          });
        } else {
          throw error;
        }
      }
      // console.log("tokenResult:", tokenResult);
      // console.log("✅ 最新 flaskAccessToken::", tokenResult.accessToken);

      // sessionStorage.setItem("flaskAccessToken", tokenResult.accessToken);
      updateAuthData("flaskAccessToken", tokenResult.accessToken);
      // 現在改成：
      setAuthToken(tokenResult.accessToken);   // 會幫你存 sessionStorage + 更新 state → 觸發 socket useEffect

      // const accessToken = response.accessToken;
      // console.log("Access Token:", accessToken);


      // 保存 accessToken 到應用狀態中
      // setAuthData(accessToken);
    } catch (e) {
      console.error("Login or token acquisition failed:", e);
    }
  };

  // useEffect(() => {
  //   console.log("AuthData.flaskAccessToken:", AuthData.flaskAccessToken)
  // }, [AuthData.flaskAccessToken])

  // const handleLogin = (loginType) => {
  //   if (loginType === "popup") {
  //     instance.loginPopup(loginRequest).catch((e) => {
  //       console.log(e);
  //     });
  //   } else if (loginType === "redirect") {
  //     instance.loginRedirect(loginRequest).catch((e) => {
  //       console.log(e);
  //     });
  //   }
  // };

  return (
    <DropdownButton
      variant="secondary"
      className="ml-auto"
      drop="start"
      title="Sign In"
    >
      <Dropdown.Item as="button" onClick={() => handleLogin("popup")}>
        Sign in using Popup
      </Dropdown.Item>
    </DropdownButton>
  );
};
      // <Dropdown.Item as="button" onClick={() => handleLogin("redirect")}>
      //   Sign in using Redirect
      // </Dropdown.Item>